module.exports = __webpack_public_path__ + "media/images/drop-down-3e7f3498.svg";